import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import SupportNav from '../SupportNav';
import Link from '../../common/TrackedLink';

class FaqChangeBatteries extends Component {
	render() {
		return (
			<div className="faq-change-batteries">
				<Helmet>
					<title>How Do I Change the Batteries on My Safe? | SentrySafe</title>
					<meta
						name="description"
						content="Learn how to change the batteries on your safe with step-by-step instructions, image references and video demonstrations."
					/>
				</Helmet>

				<SupportNav />

				<Header
					title="How Do I Change the Batteries on My Safe?"
					description=""
				/>

				<section className="section section-faq-change-batteries">
					<div className="section-content">
						<div className="row">
							<div className="col">
								<h2><b>Need Help with Your Digital Lock&#63;</b></h2>
								<p>Most digital lock problems are related to low, dead or Non&#45;Alkaline batteries. For most SentrySafe models, we recommend the following&#58;</p>
								<ul>
									<li>Refrain from using rechargeable or Non&#45;Alkaline batteries.</li>
									<li>Use quality name brand batteries.</li>
									<li>All batteries have expiration dates on them. Ensure those dates are as close to 10 years out from current year as possible.</li>
									<li>When changing batteries do not mix brands &#40;i.e. all 4 batteries should be Duracell&#41; or mix old batteries with new batteries.</li>
								</ul>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe models that begin with <b>FP and FPW</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Remove battery compartment from inside door.</li>
									<li>Insert 2-batteries as indicated <i>(Do not use rechargeable, or Non-CR123 Lithium batteries. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Replace battery compartment</li>
								</ol>
								This safe has a <i>Battery Auxiliary Override–</i><br />
								<ol>
									<li>If battery is low and unable to operate open, use Battery Auxiliary Override.</li>
									<li>This should not be used as a primary means of gaining entry into safe.</li>
									<li>Open the silicone cap found on the side of the electronic lock.</li>
									<li>Carefully remove jumper wire and attach a 9V battery.</li>
									<li>If attached properly, you will get 3 chirps from electronic lock.</li>
									<li>Enter 5 digit code, and pull handle to open.</li>
									<li>Once opened, remove 9V, replace jumper in it's storage compartment, and replace Lithium Cells inside door per instructions.</li>
									<li>Verify lock function before reclosing unit.</li>
								</ol>
								<figure>
									<img height={240} src={require('../../../resources/img/faq/change-batteries/FP-Battery-Pack_SS_001.jpg')} alt="Slide open battery cover below keypad." />
									<img height={240} src={require('../../../resources/img/faq/change-batteries/FP-Battery-Pack_SS_002.jpg')} alt="Slide open battery cover below keypad." />
									<figcaption>Slide open battery cover below keypad.</figcaption>
								</figure>
							</div>
						</div>


						<div className="row">
							<div className="col">
								<h2>For SentrySafe models that begin with <b>A3, A4, A5; J3, J4, J5; S0, S3, S4, S5, S6, S7, S8, SB, SBW, SC, SW; J3, J4, J5; L0, L3; V</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								Slide open battery cover located just below keypad:<br />
								<ol>
									<li>Insert a paper clip or pen point into small hole on left side of the cover.</li>
									<li>Push in on left side of cover while sliding it to the right.</li>
									<li>Remove battery holder.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Put battery hold back into safe.</li>
									<li>Slide cover back into place.</li>
								</ol>
								<figure>
									<img src={require('../../../resources/img/faq/change-batteries/figure-1a.jpg')} alt="Slide open battery cover below keypad." />
									<img src={require('../../../resources/img/faq/change-batteries/figure-1b.jpg')} alt="Slide open battery cover below keypad." />
									<figcaption>Slide open battery cover below keypad.</figcaption>
								</figure>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe models that begin with <b>CS, CSW, DA, DS, KS, KSW, MS, MSW, OA, OS</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Check bottom edge of electronic lock and if equipped with shipping screw, remove and dispose of.</li>
									<li>Turn electronic lock clockwise (right) and remove.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Replace the electronic lock and turn counterclockwise (left) to reattach.</li>
								</ol>
								<figure>
									<img src={require('../../../resources/img/faq/change-batteries/figure-2a.jpg')} alt="Turn electronic lock clockwise." />
									<img src={require('../../../resources/img/faq/change-batteries/figure-2b.jpg')} alt="Turn electronic lock clockwise." />
									<figcaption>Turn electronic lock clockwise.</figcaption>
								</figure>
								<div className="embed-responsive-16x9">
									<iframe src="//www.youtube.com/embed/3ENpTK07JtY" width="560" height="315" />
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe models that begin with <b>SFW082B, E, F, G; SFW123B, E, F, G; SFW205B, E, F, G; STW123G; STW205G</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Pull out the battery drawer on side of electronic lock to the right.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Replace the battery drawer by sliding it to the left.</li>
								</ol>
								<figure>
									<img src={require('../../../resources/img/faq/change-batteries/figure-3.jpg')} alt="Pull out the battery drawer." />
									<figcaption>Pull out the battery drawer.</figcaption>
								</figure>
								<div className="embed-responsive-16x9">
									<iframe src="//www.youtube.com/embed/ZLjf7QeNFPA" width="560" height="315" />
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe models that begin with <b>SFW123T, U; SFW205T, U</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Remove battery compartment from inside door.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Replace battery compartment.</li>
								</ol>
								This safe has a <i>Battery Auxiliary Override</i>&ndash;
								<ol>
									<li>If battery is low and unable to operate open, use Battery Auxiliary Override.</li>
									<li>This should not be used as a primary means of gaining entry into safe.</li>
									<li>Open the silicone cap found on the side of the electronic lock.</li>
									<li>Insert a 9 volt battery into slot.</li>
									<li>If attached properly, you will get 3 chirps from electronic lock.</li>
									<li>Touch center of electronic lock to wake up keypad.</li>
									<li>Enter 5 digit code, and turn handle to open.</li>
									<li>Once opened follow instructions above to change batteries in compartment located inside of door.</li>
								</ol>
								<div className="row">
									<div className="col md-6">
										<figure>
											<img src={require('../../../resources/img/faq/change-batteries/figure-4a.jpg')} alt="Remove battery compartment from inside of safe door." />
											<figcaption>Remove battery compartment from inside of safe door.</figcaption>
										</figure>
									</div>
									<div className="col md-6">
										<figure>
											<img src={require('../../../resources/img/faq/change-batteries/figure-4b.jpg')} alt="Enter 5-digit code and turn handle to open." />
											<figcaption>Enter 5-digit code and turn handle to open.</figcaption>
										</figure>
									</div>
								</div>
								<div className="embed-responsive-16x9">
									<iframe src="//www.youtube.com/embed/TvMLBTWJEfE" width="560" height="315" />
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe security models that begin with <b>ESB; PL</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Insert override key, and turning dial to unlock position will be required to open door.</li>
									<li>Remove battery compartment from inside lid of door.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Replace battery compartment.</li>
								</ol>
								<figure>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-5a.jpg')}
										alt="Remove battery compartment from inside lid of door."
									/>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-5b.jpg')}
										alt="Remove battery compartment from inside lid of door."
									/>
									<figcaption>Remove battery compartment from inside lid of door.</figcaption>
								</figure>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe security models that begin with <b>QAP1E, QAPBE1, QAP2E, QAP2EL</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Insert and turn clockwise (right) override key to unlock position will be required to open door.</li>
									<li>Pull out battery pack (keep battery pack connected to wires).</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Replace battery pack cover.</li>
								</ol>
								<figure>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-6a.jpg')}
										alt="Pull out battery pack."
									/>
									<figcaption>Pull out battery pack.</figcaption>
								</figure>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe security models that begin with <b>CA; HL</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Unscrew and remove override key lock cap.</li>
									<li>Insert key and turn counterclockwise (left) to unlock door (notch on key in upward position).</li>
									<li>Open door, remove battery compartment cover in direction arrows are pointing.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Slide battery compartment cover back into place (make sure cover is locked in place).</li>
								</ol>
								<figure>
									<img src={require('../../../resources/img/faq/change-batteries/figure-7a.jpg')} alt="Override key lock cap." />
									<img src={require('../../../resources/img/faq/change-batteries/figure-7b.jpg')} alt="Override key lock cap." />
									<img src={require('../../../resources/img/faq/change-batteries/figure-7c.jpg')} alt="Override key lock cap." />
									<figcaption>Override key lock cap.</figcaption>
								</figure>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe models that begin with <b>X</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Remove cover to override key between dial and keypad.</li>
									<li>Insert key and turn counterclockwise (left), then turn dial clockwise (right) to open door.</li>
									<li>Remove battery compartment cover in direction arrows are pointing.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Slide battery compartment cover back into place (make sure cover is locked in place).</li>
								</ol>
								<figure>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-8a.jpg')}
										alt="Remove battery compartment cover."
									/>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-8b.jpg')}
										alt="Remove battery compartment cover."
									/>
									<figcaption>Remove battery compartment cover.</figcaption>
								</figure>
							</div>
						</div>

						<div className="row">
							<div className="col">

								<h2>For SentrySafe security models that begin with <b>T</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Turn electronic lock counterclockwise (left) and remove.</li>
									<li>Unlock door with override key, pull handle down to open.</li>
									<li>Remove key hook plate located on backside of door by sliding upward.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Slide key hook plate back into place (make sure cover is locked in place).</li>
								</ol>
								<figure>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-9.jpg')}
										alt="Turn electronic lock clockwise and remove. Slide key hook plate back into place."
									/>
									<figcaption>Turn electronic lock clockwise and remove. Slide key hook plate back into place.</figcaption>
								</figure>
							</div>
						</div>

						<div className="row">
							<div className="col">
								<h2>For SentrySafe security models that begin with <b>DH</b>:</h2>
								<p className="text-center">
									Don&rsquo;t know your model number? <Link to="/support/find-your-model-or-serial-number">Find it here</Link>.
								</p>
								<ol>
									<li>Turn electronic lock counterclockwise (left) and carefully pull away from mounting plate.</li>
									<li>Insert 4-batteries as indicated <i>(Do not use rechargeable, or Non-Alkaline. Do not mix old with new batteries or mix brands of batteries)</i>.</li>
									<li>Carefully position keypad on mounting place.</li>
									<li>Ensure no wires are between keypad and mounting plate to avoid pinching of wires.</li>
									<li>Turn keypad clockwise (right) to attach to mounting plate.</li>
								</ol>
								<figure>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-10a.jpg')}
										alt="Turn electronic lock clockwise and pull away from mounting plate."
									/>
									<img
										src={require('../../../resources/img/faq/change-batteries/figure-10b.jpg')}
										alt="Turn electronic lock clockwise and pull away from mounting plate."
									/>
									<figcaption>Turn electronic lock clockwise and pull away from mounting plate.</figcaption>
								</figure>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
};

export default FaqChangeBatteries;


// WEBPACK FOOTER //
// ./src/pages/support/faqs/HowDoIChangeBatteries.js